module.exports = __webpack_public_path__ + "img/no-collection.57dd5e42.png";